import { ContextStore } from '../../../react-core/Flux/Variables';
import { RoutesHelper } from '../../../react-core/Utils/RoutesHelper';
import { AjaxWrapper } from '../../../react-core/Async/AjaxWrapper';
import { Promise } from '../../../react-core/Async/Promise';
import { RetirementDateResponse } from '../../Models/Models/Customer/RetirementDateResponse';
import { IJsonDate } from '../../System/IJsonDate';

declare var IS_RUNNING_IN_APP_POOL;

export class RetirementDateClient {
  private _culture: string;

  public constructor() {
    var contextStoreState = ContextStore.getContext();
    this._culture = contextStoreState.culture;
  }

  public put(customerId: number, retirementDate: IJsonDate): Promise<RetirementDateResponse, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/Customer/RetirementDate/Put';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { customerId: customerId, retirementDate: retirementDate }

    return AjaxWrapper.put<RetirementDateResponse, any>(url, data);
  }
}

